import FontIcon from 'components/icons/FontIcon';
import { FileHelpBox } from 'components/v2/help-boxes';
import { Button } from 'primereact/button';
import React, { useId } from 'react';
import { FileModel } from 'services/EpdClient';
import FileService from 'services/FileService';
import styled from 'styled-components';

import useIsReadOnlyMode from '../compiler/hooks/useIsReadOnlyMode';
import Tooltip from 'components/controls/Tooltip';

export const FileRow: React.FunctionComponent<{
  file?: FileModel;
  onRemoveFile?(): void;
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
}> = ({ file, onRemoveFile, disabled, style, className }) => {
  const downloadButtonId = useId();
  const removeButtonId = useId();
  const isReadOnly = useIsReadOnlyMode() || disabled;

  if (!file || !file.id) {
    return null;
  }

  const fileUrl = FileService.getImageUrl(file.id || '');

  return (
    <FileHelpBox className={className} style={{ overflow: 'hidden', ...style }}>
      <Text>
        {file?.name}
        <Tooltip position="title">{file?.name}</Tooltip>
      </Text>
      <div style={{ display: 'flex', alignItems: 'center', maxHeight: '1rem' }}>
        {file && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button id={downloadButtonId} text icon="pi pi-download" onClick={() => window.open(fileUrl, '_blank')} />{' '}
            <Tooltip targetId={downloadButtonId} position="title">
              Download file
            </Tooltip>
            {!isReadOnly && file.isRemovable && (
              <>
                <Button id={removeButtonId} text icon={<FontIcon icon="delete" />} onClick={onRemoveFile} />
                <Tooltip targetId={removeButtonId} position="title">
                  Remove file
                </Tooltip>
              </>
            )}
          </div>
        )}
      </div>
    </FileHelpBox>
  );
};

const Text = styled.span`
  overflow: hidden;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export default FileRow;
